//验证手机号
const validatePhone = (rule, value, callback) => {
    let patter = new RegExp("^1[3|4|5|7|8][0-9]{9}$");
    if (value == undefined) {
        return callback();
    }
    if (patter.test(value) || '' === value) {
        return callback();
    } else {
        return callback(new Error("请输入正确格式的手机号！"));
    }
};


const checkSpace = (rule, value, callback) => {

    if (/^\d+$/.test(value)) {
        return callback();
    } else {
        return callback(new Error("请输入正整数！"));
    }
};


// 验证1-9正整数
const checkUserNum = (rule, value, callback) => {

    if (/^[1-9]$/.test(value)) {
        return callback();
    } else {
        return callback(new Error("请输入1-9正整数！"));
    }
};




const checkP = (rule, value, callback) => {
    if (value == undefined || value.length == 0) {
        return callback(new Error("请选择权限！"));
    } else {
        return callback();
    }
};
export default {
    userName: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
    },], //用户名验证

    permission: [{
        required: true,
        message: "请选择权限",
        trigger: "change",
        validator: checkP,
    }], //权限
    password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
    }], //密码验证
    oldPassword: [{
        required: true,
        message: "请输入旧密码",
        trigger: "blur"
    }], //旧密码验证
    newPassword: [{
        required: true,
        message: "请输入新密码",
        trigger: "blur"
    }], //新密码验证
    againPassword: [{
        required: true,
        message: "请输入确认密码",
        trigger: "blur"
    }], //再次密码验证

    goodName: [{
        required: true,
        message: "请输入货名",
        trigger: "blur"
    },],

    unitName: [{
        required: true,
        message: "请输入单位名称",
        trigger: "blur"
    },],

    spec: [{
        required: true,
        message: "请输入规格",
        trigger: "blur"
    },],

    companyCloudID: [{
        required: true,
        message: "请输入绑定企业云ID",
        trigger: "blur"
    }],

    companyCloudPSW: [{
        required: true,
        message: "请输入绑定企业密码",
        trigger: "blur",
    },],

    companyCloudName: [{
        required: true,
        message: "请输入绑定企业名称",
        trigger: "blur",
    }],

    // admin新增

    customersName: [{
        required: true,
        message: "请输入企业名称",
        trigger: "blur",
    }],

    customersID: [{
        required: true,
        message: "请输入企业云ID",
        trigger: "blur",
    }],

    loginID: [{
        required: true,
        message: "请输入登录账号",
        trigger: "blur",
    }],

    loginPsw: [{
        required: true,
        message: "请输入登录密码",
        trigger: "blur",
    }],


    space: [{
        message: "请输入整数",
        trigger: "blur",
        validator: checkSpace,
    }],


    userNum: [{
        message: "请输入1-9的整数",
        trigger: "blur",
        validator: checkUserNum,
    }],


    // 预约信息 免审核预约 车号
    carNo: [{
        required: true,
        message: "请输入车号",
        trigger: "blur",
    }],


}


// WEBPACK FOOTER //
// ./src/api/rules.js